<template>
  <div class="count_text">
    <div class="black" v-if="isOver">已结束</div>
    <div class="red" v-else>
      <van-count-down
        :time="lastTime"
        @change="downChange"
        @finish="activelFinish"
      >
        <template #default="timeData">
          <span class="time_item" v-if="timeData.days > 0">{{
            timeData.days
          }}</span>
          <span class="day" v-if="timeData.days > 0">天</span>
          <span class="time_item">{{ timeData.hours }}</span>
          <span class="item">:</span>
          <span class="time_item">{{ timeData.minutes }}</span>
          <span class="item">:</span>
          <span class="time_item">{{ timeData.seconds }}</span>
          <span class="time_item">后结束</span>
        </template>
      </van-count-down>
    </div>
  </div>
</template>

<script>
export default {
  name: "countDown",
  props: {
    lastTime: {
      type: String,
      default: () => "",
    },
    index: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      isOver: false,
    };
  },
  computed: {},
  methods: {
    downChange(e) {
      if (e.hours < 10) {
        e.hours = `0${e.hours}`;
      }
      if (e.minutes < 10) {
        e.minutes = `0${e.minutes}`;
      }
      if (e.seconds < 10) {
        e.seconds = `0${e.seconds}`;
      }
    },
    activelFinish() {
      this.isOver = true;
      this.$emit("over", this.index);
    },
  },
  created() {},
  mounted() {
    // if (currentDate < startDate) {
    //   console.log("没有开始");
    //   this.isBegin = false;
    // } else {
    //   this.isBegin = true;
    // }
  },
};
</script>

<style scoped lang="scss">
.count_text {
  font-size: 13px;
  .black {
    color: #333;
  }
  .red .van-count-down {
    color: #ff2624;
    font-size: 13px;
  }
}
</style>
